<template lang="pug">
.swipe-container(:class="{'external-dots': externalDots}")
  .slides#slides
    slot
  .slider-dots
    .dot-container(v-for="i in slides", @click="changeSlide(i-1)")
      .dot(:class="{'selected': selectedDot === i - 1}")
</template>

<script>
export default {
  name: 'c_slider',
  props: ['slides', 'external-dots'],
  data() {
    return {
      selectedDot: 0,
      timeout: null,
      timeoutTime: 5000,
      isDraggingSlide: false,
      startX: 0
    }
  },
  created() {
    let vm = this
    vm.timeout = setTimeout(() => vm.changeSlide(vm.selectedDot + 1), vm.timeoutTime)
  },
  mounted() {
    let vm = this

    let slidesContainer = document.getElementById('slides')
    slidesContainer.addEventListener('mousedown', (e) => {
      vm.isDraggingSlide = true;
      vm.startX = e.pageX - slidesContainer.offsetLeft;
    });
    slidesContainer.addEventListener('mouseleave', () => {
      vm.isDraggingSlide = false;
    });
    slidesContainer.addEventListener('mouseup', (e) => {
      vm.isDraggingSlide = false;
      let endX = e.pageX - slidesContainer.offsetLeft;
      if (vm.startX > endX) {
        vm.changeSlide(vm.selectedDot + 1)
      } else {
        vm.changeSlide(vm.selectedDot - 1)
      }
    });
    slidesContainer.addEventListener('mousemove', (e) => {
      if (!vm.isDraggingSlide) return;
      e.preventDefault();
      const x = e.pageX - slidesContainer.offsetLeft;
      const walk = (x - vm.startX) * 10; // scroll-normal
      slidesContainer.scrollLeft = slidesContainer.scrollLeft - walk;
    });
    slidesContainer.addEventListener('scroll', () => {
      let scrollWhere = slidesContainer.scrollLeft / slidesContainer.scrollWidth
      let factor = 1 / vm.slides
      if (scrollWhere % factor === 0) vm.changeSlide(scrollWhere / factor)
    })
  },
  unmounted() {
    let vm = this
    clearTimeout(vm.timeout)

    let slidesContainer = document.getElementById('slides')
    slidesContainer.removeEventListener('mousedown', (e) => {
      vm.isDraggingSlide = true;
      vm.startX = e.pageX - slidesContainer.offsetLeft;
    });
    slidesContainer.removeEventListener('mouseleave', () => {
      vm.isDraggingSlide = false;
    });
    slidesContainer.removeEventListener('mouseup', (e) => {
      vm.isDraggingSlide = false;
      let endX = e.pageX - slidesContainer.offsetLeft;
      if (vm.startX > endX) {
        vm.changeSlide(vm.selectedDot + 1)
      } else {
        vm.changeSlide(vm.selectedDot - 1)
      }
    });
    slidesContainer.removeEventListener('mousemove', (e) => {
      if (!vm.isDraggingSlide) return;
      e.preventDefault();
      const x = e.pageX - slidesContainer.offsetLeft;
      const walk = (x - vm.startX) * 10; // scroll-normal
      slidesContainer.scrollLeft = slidesContainer.scrollLeft - walk;
    });
    slidesContainer.removeEventListener('scroll', () => {
      let scrollWhere = slidesContainer.scrollLeft / slidesContainer.scrollWidth
      let factor = 1 / vm.slides
      if (scrollWhere % factor === 0) vm.changeSlide(scrollWhere / factor)
    })
  },
  destroyed() {
    clearTimeout(this.timeout)
  },
  methods: {
    changeSlide(slide) {
      let vm = this
      clearTimeout(vm.timeout)
      if (slide >= vm.slides) vm.selectedDot = 0
      else if (slide <= 0) vm.selectedDot = 0
      else vm.selectedDot = slide
      let element = document.getElementById('slides')
      element.scrollLeft = vm.selectedDot * (element.scrollWidth / vm.slides)
      vm.timeout = setTimeout(() => vm.changeSlide(vm.selectedDot + 1), vm.timeoutTime)
    }
  }
}
</script>

<style lang="stylus" scoped>
.swipe-container
  overflow hidden
  position relative
  .slides
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  .slide
    scroll-snap-align: start;
    min-width: 100%
    min-height 100%
    margin 0
    border-radius 0
    cursor grab
    padding 1.5rem 2.5rem 2.5rem 1.5rem;

  .slides::-webkit-scrollbar
    display none

  .slider-dots
    display flex
    justify-content center
    margin-top 5px
    position absolute
    bottom 5px
    width 100%
    .dot-container
      padding 10px 1px
      cursor pointer
    .dot
      border-radius 50%
      border 1px solid #4b4b4b
      margin-left 5px
      transition width ease .3s
      width: 7.5px;
      height: 7.5px;
      background-color: #4b4b4b
      &.selected
        width 14px 
        border-radius 4px

.external-dots
  .slides
    margin-bottom 20px
  .slide
    padding 0px
  .slider-dots
    bottom -10px

html.dark, body.dark
  .external-dots
    .slider-dots
      .dot
        background-color #fff
        border 1px solid #fff

</style>



// WEBPACK FOOTER //
// c_slider.vue?5dc30124